<template>
  <div class="commodity-list">
    <div
      v-for="(item, index) in comList"
      :key="index"
      class="commodity-item"
      @click="onTapToDetail(item)"
    >
      <img v-if="item.FCover" :src="item.FCover" alt="">
      <img v-else src="../../../../assets/images/stockImg.jpg" alt="">
      <div class="commodity-detail">详情</div>
      <div class="commodity-name">{{ item.FName }}</div>
      <!-- v-html="setPrice(item)" -->
      <div class="commodity-price">
        ¥<span style="font-size:20px;">{{ item.fStockPrice }}</span>
        <!-- .<span style="font-size:14px;" /> -->
        <span v-if="item.FMeasurement">
          /{{ item.FMeasurement }}
        </span>
        <span style="font-size:14px;text-decoration:line-through;color:#666;margin-left:5px;">
          ¥{{ item.FPrice }}
          <span v-if="item.FMeasurement">
            /{{ item.FMeasurement }}
          </span>
        </span>
      </div>
      <!-- <div class="commodity-price" v-html="setPrice(item)" /> -->
    </div>

  </div>
</template>

<script>
export default {
  props: {
    // 默认应该是一个数组，等接口有了改成接收数组类型的数据
    comList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {

    }
  },
  watch: {

  },
  created() {

  },
  methods: {
    setPrice(item) {
      const arr = [item.FNoAPPrice, item.FOnMAPPrice, item.FTwMAPPrice, item.FThMAPPrice, item.FFoMAPPrice, item.FFiMAPPrice]
      const showPrice = arr[Number(item.fDayLimit)]
      const showSpliPrice = showPrice !== undefined ? showPrice.toString().split('.') : 0
      let ii = showSpliPrice[1]
      if (ii === undefined) {
        ii = '00'
      }
      // ps:v-html绑定数据
      // 1.分割价钱 => ["88888", "00"]
      const splitPrice = item.fStockPrice !== undefined ? item.fStockPrice.toString().split('.') : 0
      // 2.重新赋值
      let i = splitPrice[1]
      if (i === undefined) {
        i = '00'
      }
      return `¥<span style="font-size:20px;">${item.fStockPrice}</span>.<span style="font-size:14px;"></span>/${item.FMeasurement}<span style="font-size:14px;text-decoration:line-through;color:#666;margin-left:5px;">¥${item.FPrice}/${item.FMeasurement}</span>`
    },
    onTapToDetail(val) {
      const routeUrl = this.$router.resolve({
        path: '/store/details',
        redirect: '',
        query: {
          mallstorestockFId: val.mallstorestockFId,
          shopid: val.mallstoreFID
        }
      })
      window.open(routeUrl.href, '_blank') // 新标签页打开商品详情
    }

  }
}
</script>

<style lang="scss" scoped>
.commodity-list {
    min-height: 450px;
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;

  .commodity-item {
    width: 234px;
    height: 325px;
    background: #ffffff;
    border: 1px solid #d2d2d2;
    padding: 10px;
    margin-right: 7px;
    margin-bottom: 6px;
    position: relative;
    cursor: pointer;
    &:nth-child(5n) {
      margin-right: 0;
    }
    &:hover {
      border: 1px solid #ec212d;
      box-shadow: 0px 0px 10px 0px rgba(236, 33, 45, 0.1);
      .commodity-detail {
        display: block;
      }
    }
    img {
      width: 214px;
      height: 214px;
    }
    .commodity-name {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      margin-top: 15px;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1; //此处为行数，可以改为任意数字
    }
    .commodity-price {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 500;
      color: #ec212d;
      margin-top: 8px;
      overflow: hidden;
    }
    .commodity-detail {
      position: absolute;
      width: 100%;
      height: 46px;
      text-align: center;
      line-height: 46px;
      background: linear-gradient(0deg, #ec212d 0%, rgba(236, 33, 45, 0) 100%);
      color: #fff;
      left: 0;
      bottom: 80px;
      display: none;
      font-size: 14px;
    }
  }
}
</style>
